export default __webpack_public_path__ + "static/media/firstAgency.7882f9ae.svg";